"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDictionary = exports.isDictionaryItem = void 0;
function isDictionaryItem(a) {
    return typeof a.code === 'string';
}
exports.isDictionaryItem = isDictionaryItem;
function isDictionary(a) {
    return typeof a.code !== 'string';
}
exports.isDictionary = isDictionary;
